module.exports = __webpack_public_path__ + "static/media/image1.9aafbda3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image1.jpg
// module id = 35
// module chunks = 0